export abstract class BaseOnboardingSection {
	
	public readonly: boolean;
	public guid: string;
	
	public abstract save: () => Promise<any>;

	protected onActivated() {

	}

	public activate(model) {
		this.readonly = model.readonly;
		this.guid = model.guid;

		this.onActivated();
	}
}
